import React, { useState, useEffect } from "react";
import { Form, Card } from "antd";
import "antd/dist/antd.css";
import "./ResetPassword.scss";
import MainButton from "../../components/MainButton/MainButton.jsx";
import TextInput from "../../components/TextInput/TextInput.jsx";
import { useNavigate } from "react-router-dom";
import { verifyMobile } from "../../api/apiStore/Register/Register";
import ConfirmModal from "../../components/ConfirmModal";
import logo from "../../assets/img/img_common_form_logo_n@2x.png";
import Loading from "../../components/Loading/Loading.jsx";

export default function ResetPassword() {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const [confirmModal, setConfirmModal] = useState({
    title: "提示",
    visible: false,
  });
  const [confirmModalMsg, setConfirmModalMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const register1Value = JSON.parse(sessionStorage.getItem("register1"));
  // const register2Value = JSON.parse(sessionStorage.getItem("register2"));
  // const allRegisterData = { ...register1Value, ...register2Value };
  // const resetPwdHandler = async ({ account, oldPassword, newPassword }) => {
  //   const resp = await changePassword({ account, oldPassword, newPassword });
  //   return resp;
  // };
  const verifyMobileHandler = async () => {
    setIsLoading(true);
    const verifyResp = await verifyMobile();
    setIsLoading(false);
    return;
  };
  const onFinish = () => {
    form
      .validateFields()
      .then(async (values) => {
        // resetPwdHandler();
        register1Value.mobile = values.mobile;
        sessionStorage.setItem("register1", JSON.stringify(register1Value));
        const resp = verifyMobileHandler();
        if (resp.RC !== "C01") {
          setConfirmModal(() => {
            return { title: "提示", visible: true };
          });
          setConfirmModalMsg("請重新操作一次");
        }
        navigate("/registerFinal");
      })
      .catch((error) => {
        const { errorFields } = error;
        const filterErrorMsg = errorFields.map((item) => {
          const { errors } = item;
          item.errors = [...new Set(errors)];
          return item;
        });
      });
  };
  const handleOk = () => {};

  return (
    <div>
      <Loading isLoadingVisible={isLoading}></Loading>
      <Card type="inner" className="resetPasswordPage-basic">
        {/* <Title level={2} className="page-title">
          忘記密碼
        </Title> */}
        {/* {isErrorModalVisible ? (
          <ErrorHandler errorList={isErrorModalVisible} />
        ) : null} */}
        <img style={{ width: "100%", height: "100%" }} src={logo} />
        <Form
          form={form}
          name="basic"
          autoComplete="off"
          validateTrigger="onSubmit"
        >
          <Form.Item
            name="mobile"
            rules={[
              {
                required: true,
                message: "手機號碼為必填",
              },
              {
                len: 10,
                message: "手機號碼格式錯誤",
              },
            ]}
          >
            <TextInput title="手機號碼" placeholder="請輸入新的手機號碼" />
          </Form.Item>
          <MainButton buttonType="main" onClick={onFinish}>
            確定
          </MainButton>
        </Form>
      </Card>
      {confirmModal.visible ? (
        <ConfirmModal
          title={confirmModal.title}
          setModalvisible={confirmModal.visible}
          setHandleOk={handleOk}
          msg={confirmModalMsg}
        />
      ) : null}
      {/* <Loading isLoadingVisible={isLoading}></Loading> */}
    </div>
  );
}
